// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"f7f77464","78":"63334b9f","266":"8896b4cb","760":"1cfc71bf","787":"b27904cc","922":"518caab1","924":"6f837026"}[chunkId] + ".chunk.js";
};